// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700&family=Manrope:wght@400;500;700&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

/* Light Theme (Default) */

:root {
        --background: 210 40% 98%;
        --foreground: 222 47% 11%;
        --card: 0 0% 100%;
        --card-foreground: 222 47% 11%;
        --popover: 0 0% 100%;
        --popover-foreground: 222 47% 11%;
        --primary: 118 72% 37%;
        --primary-foreground: 0 0% 100%;
        --secondary: 210 40% 96%;
        --secondary-foreground: 222 47% 11%;
        --muted: 210 40% 96%;
        --muted-foreground: 215 16% 47%;
        --accent: 118 72% 37%;
        --accent-foreground: 0 0% 100%;
        --destructive: 4 84% 60%;
        --destructive-foreground: 0 0% 100%;
        --border: 214 32% 91%;
        --input: 214 32% 91%;
        --ring: 118 72% 37%;
        --chart-1: 118 72% 37%;
        --chart-2: 145 80% 42%;
        --chart-3: 48 100% 50%;
        --chart-4: 4 84% 60%;
        --chart-5: 280 70% 60%;
        --radius: 0.375rem;
        --success: 145 80% 42%;
        --warning: 48 100% 50%;

        /* Theme-specific colors */
        --bg-primary: #F8FAFC;
        --bg-secondary: #FFFFFF;
        --bg-tertiary: #F1F5F9;
        --text-primary: #1E293B;
        --text-secondary: #64748B;
        --text-muted: #94A3B8;
        --border-color: #E2E8F0;
        --border-light: #F1F5F9;
        --sidebar-bg: #FFFFFF;
        --sidebar-border: #E2E8F0;
        --sidebar-text: #64748B;
        --sidebar-text-active: #1a8220;
        --sidebar-bg-active: #f0fdf4;
        --header-bg: rgba(255, 255, 255, 0.8);
        --card-bg: #FFFFFF;
        --input-bg: #F8FAFC;
        --scrollbar-track: #F1F5F9;
        --scrollbar-thumb: #CBD5E1;
        --scrollbar-thumb-hover: #94A3B8;
    }

/* Dark Theme */

[data-theme="dark"] {
        --background: 222 47% 7%;
        --foreground: 210 40% 92%;
        --card: 222 47% 11%;
        --card-foreground: 210 40% 92%;
        --popover: 222 47% 9%;
        --popover-foreground: 210 40% 92%;
        --primary: 118 60% 50%;
        --primary-foreground: 0 0% 100%;
        --secondary: 222 47% 14%;
        --secondary-foreground: 210 40% 80%;
        --muted: 222 47% 14%;
        --muted-foreground: 215 20% 45%;
        --accent: 118 60% 50%;
        --accent-foreground: 0 0% 100%;
        --destructive: 4 84% 60%;
        --destructive-foreground: 0 0% 100%;
        --border: 222 47% 16%;
        --input: 222 47% 14%;
        --ring: 118 60% 50%;
        --chart-1: 118 60% 55%;
        --chart-2: 145 60% 55%;
        --chart-3: 48 90% 60%;
        --chart-4: 4 84% 60%;
        --chart-5: 280 60% 65%;
        --radius: 0.5rem;
        --success: 145 60% 55%;
        --warning: 48 90% 60%;

        /* Theme-specific colors */
        --bg-primary: #060d1a;
        --bg-secondary: #0a1628;
        --bg-tertiary: #0d1f35;
        --text-primary: #e2e8f0;
        --text-secondary: #94a3b8;
        --text-muted: #475569;
        --border-color: rgba(30, 41, 59, 0.9);
        --border-light: rgba(15, 23, 42, 0.6);
        --sidebar-bg: #0a1628;
        --sidebar-border: rgba(30, 41, 59, 0.8);
        --sidebar-text: #64748b;
        --sidebar-text-active: #4ade80;
        --sidebar-bg-active: rgba(26, 130, 32, 0.08);
        --header-bg: rgba(10, 22, 40, 0.95);
        --card-bg: #0d1f35;
        --input-bg: #0d1f35;
        --accent-color: #1a8220;
        --scrollbar-track: #0a1628;
        --scrollbar-thumb: #1e293b;
        --scrollbar-thumb-hover: #334155;
    }

/* Banking Theme — Modern Banking White */

[data-theme="banking"] {
        --background: 210 40% 98%;
        --foreground: 222 47% 11%;
        --card: 0 0% 100%;
        --card-foreground: 222 47% 11%;
        --popover: 0 0% 100%;
        --popover-foreground: 222 47% 11%;
        --primary: 118 72% 37%;
        --primary-foreground: 0 0% 100%;
        --secondary: 210 40% 96%;
        --secondary-foreground: 222 47% 11%;
        --muted: 210 40% 96%;
        --muted-foreground: 215 16% 47%;
        --accent: 118 72% 37%;
        --accent-foreground: 0 0% 100%;
        --destructive: 4 84% 60%;
        --destructive-foreground: 0 0% 100%;
        --border: 214 32% 91%;
        --input: 214 32% 91%;
        --ring: 118 72% 37%;
        --radius: 0.5rem;

        /* Theme-specific colors */
        --bg-primary: #f8fafc;
        --bg-secondary: #ffffff;
        --bg-tertiary: #f1f5f9;
        --text-primary: #1e293b;
        --text-secondary: #64748b;
        --text-muted: #94a3b8;
        --border-color: #e2e8f0;
        --border-light: #f8fafc;
        --sidebar-bg: #0f172a;
        --sidebar-border: #1e293b;
        --sidebar-text: #64748b;
        --sidebar-text-active: #86efac;
        --sidebar-bg-active: rgba(26, 130, 32, 0.15);
        --header-bg: rgba(255, 255, 255, 0.9);
        --card-bg: #ffffff;
        --input-bg: #f8fafc;
        --accent-color: #1a8220;
        --scrollbar-track: #f1f5f9;
        --scrollbar-thumb: #cbd5e1;
        --scrollbar-thumb-hover: #94a3b8;
    }

*{
  border-color: hsl(var(--border));
        /* Remove iOS tap delay on all interactive elements */
        touch-action: manipulation;
}

body {
        background-color: var(--bg-primary);
        color: var(--text-primary);
        font-family: var(--app-font, 'Inter', 'Manrope', sans-serif);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-tap-highlight-color: transparent;
        overscroll-behavior: none;
    }

/* Banking: Plus Jakarta Sans / Inter for all elements */

[data-theme="banking"] body,
    [data-theme="banking"] * {
        font-family: var(--app-font, 'Plus Jakarta Sans', 'Inter', sans-serif) !important;
    }

h1, h2, h3, h4, h5, h6 {
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        letter-spacing: -0.02em;
    }

code, .font-mono {
        font-family: 'JetBrains Mono', monospace;
    }
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-20{
  bottom: -5rem;
}
.-left-12{
  left: -3rem;
}
.-left-20{
  left: -5rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-12{
  right: -3rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-24{
  right: -6rem;
}
.-right-3{
  right: -0.75rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-12{
  top: -3rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-3{
  top: -0.75rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[42px\\]{
  top: 42px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-full{
  grid-column: 1 / -1;
}
.float-right{
  float: right;
}
.clear-both{
  clear: both;
}
.-m-1{
  margin: -0.25rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-3{
  margin-left: -0.75rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[92vh\\]{
  height: 92vh;
}
.h-\\[calc\\(100vh-120px\\)\\]{
  height: calc(100vh - 120px);
}
.h-\\[calc\\(100vh-420px\\)\\]{
  height: calc(100vh - 420px);
}
.h-\\[calc\\(100vh-480px\\)\\]{
  height: calc(100vh - 480px);
}
.h-\\[calc\\(100vh-540px\\)\\]{
  height: calc(100vh - 540px);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[140px\\]{
  max-height: 140px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[250px\\]{
  max-height: 250px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[45vh\\]{
  max-height: 45vh;
}
.max-h-\\[55vh\\]{
  max-height: 55vh;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[65vh\\]{
  max-height: 65vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(90vh-60px\\)\\]{
  max-height: calc(90vh - 60px);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-screen{
  min-height: 100vh;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[--radix-popover-trigger-width\\]{
  width: var(--radix-popover-trigger-width);
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[135px\\]{
  width: 135px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[155px\\]{
  width: 155px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[185px\\]{
  width: 185px;
}
.w-\\[190px\\]{
  width: 190px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-48{
  min-width: 12rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[110px\\]{
  min-width: 110px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[130px\\]{
  min-width: 130px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.min-w-max{
  min-width: max-content;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[110px\\]{
  max-width: 110px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[80px\\]{
  max-width: 80px;
}
.max-w-\\[95vw\\]{
  max-width: 95vw;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.scroll-mt-4{
  scroll-margin-top: 1rem;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-\\[140px_80px_120px_90px_120px_150px_100px_100px_auto\\]{
  grid-template-columns: 140px 80px 120px 90px 120px 150px 100px 100px auto;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-end{
  align-self: flex-end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-bl-sm{
  border-bottom-left-radius: calc(var(--radius) - 4px);
}
.rounded-br-sm{
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#0B0C10\\]{
  --tw-border-opacity: 1;
  border-color: rgb(11 12 16 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0B3D91\\]{
  --tw-border-opacity: 1;
  border-color: rgb(11 61 145 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1a8220\\]{
  --tw-border-opacity: 1;
  border-color: rgb(26 130 32 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1a8220\\]\\/30{
  border-color: rgb(26 130 32 / 0.3);
}
.border-\\[\\#1e293b\\]{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1e293b\\]\\/80{
  border-color: rgb(30 41 59 / 0.8);
}
.border-\\[\\#2a2d3e\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 45 62 / var(--tw-border-opacity, 1));
}
.border-\\[\\#4f46e5\\]\\/30{
  border-color: rgb(79 70 229 / 0.3);
}
.border-\\[\\#4f46e5\\]\\/40{
  border-color: rgb(79 70 229 / 0.4);
}
.border-\\[\\#66FCF1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(102 252 241 / var(--tw-border-opacity, 1));
}
.border-\\[\\#66FCF1\\]\\/20{
  border-color: rgb(102 252 241 / 0.2);
}
.border-\\[\\#66FCF1\\]\\/30{
  border-color: rgb(102 252 241 / 0.3);
}
.border-\\[\\#66FCF1\\]\\/50{
  border-color: rgb(102 252 241 / 0.5);
}
.border-\\[\\#e2e8f0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/30{
  border-color: rgb(59 130 246 / 0.3);
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-border{
  border-color: hsl(var(--border));
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5);
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-foreground{
  border-color: hsl(var(--foreground));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-500\\/30{
  border-color: rgb(107 114 128 / 0.3);
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-200\\/10{
  border-color: rgb(187 247 208 / 0.1);
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-400\\/30{
  border-color: rgb(74 222 128 / 0.3);
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-green-500\\/30{
  border-color: rgb(34 197 94 / 0.3);
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-600\\/30{
  border-color: rgb(79 70 229 / 0.3);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.border-orange-400\\/30{
  border-color: rgb(251 146 60 / 0.3);
}
.border-orange-500\\/20{
  border-color: rgb(249 115 22 / 0.2);
}
.border-orange-600{
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/20{
  border-color: hsl(var(--primary) / 0.2);
}
.border-primary\\/30{
  border-color: hsl(var(--primary) / 0.3);
}
.border-primary\\/40{
  border-color: hsl(var(--primary) / 0.4);
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-primary\\/80{
  border-color: hsl(var(--primary) / 0.8);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-400{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}
.border-purple-400\\/30{
  border-color: rgb(192 132 252 / 0.3);
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-500\\/30{
  border-color: rgb(168 85 247 / 0.3);
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3);
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-400\\/30{
  border-color: rgb(148 163 184 / 0.3);
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity, 1));
}
.border-slate-500\\/30{
  border-color: rgb(100 116 139 / 0.3);
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/30{
  border-color: rgb(139 92 246 / 0.3);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-yellow-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity, 1));
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/30{
  border-color: rgb(234 179 8 / 0.3);
}
.border-yellow-600{
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#66FCF1\\]{
  --tw-border-opacity: 1;
  border-left-color: rgb(102 252 241 / var(--tw-border-opacity, 1));
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-green-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-l-orange-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-l-orange-500\\/50{
  border-left-color: rgb(249 115 22 / 0.5);
}
.border-l-primary{
  border-left-color: hsl(var(--primary));
}
.border-l-red-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-l-yellow-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-t-slate-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#060d1a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(6 13 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B0C10\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 12 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a1628\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 22 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d1f35\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(13 31 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f1117\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 17 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1F2833\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(31 40 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1d2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 29 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a8220\\]\\/10{
  background-color: rgb(26 130 32 / 0.1);
}
.bg-\\[\\#1a8220\\]\\/15{
  background-color: rgb(26 130 32 / 0.15);
}
.bg-\\[\\#1a8220\\]\\/20{
  background-color: rgb(26 130 32 / 0.2);
}
.bg-\\[\\#1e293b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2a2d3e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 62 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4f46e5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4f46e5\\]\\/15{
  background-color: rgb(79 70 229 / 0.15);
}
.bg-\\[\\#4f46e5\\]\\/20{
  background-color: rgb(79 70 229 / 0.2);
}
.bg-\\[\\#66FCF1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(102 252 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#66FCF1\\]\\/10{
  background-color: rgb(102 252 241 / 0.1);
}
.bg-\\[\\#66FCF1\\]\\/5{
  background-color: rgb(102 252 241 / 0.05);
}
.bg-\\[\\#F8FAFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e2e8f0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fafc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/5{
  background-color: rgb(255 251 235 / 0.05);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15{
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-background\\/60{
  background-color: hsl(var(--background) / 0.6);
}
.bg-background\\/70{
  background-color: hsl(var(--background) / 0.7);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/15{
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-card\\/40{
  background-color: hsl(var(--card) / 0.4);
}
.bg-card\\/50{
  background-color: hsl(var(--card) / 0.5);
}
.bg-card\\/95{
  background-color: hsl(var(--card) / 0.95);
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500\\/10{
  background-color: rgb(6 182 212 / 0.1);
}
.bg-cyan-500\\/20{
  background-color: rgb(6 182 212 / 0.2);
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15{
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20{
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500\\/20{
  background-color: rgb(107 114 128 / 0.2);
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/30{
  background-color: rgb(240 253 244 / 0.3);
}
.bg-green-50\\/5{
  background-color: rgb(240 253 244 / 0.05);
}
.bg-green-50\\/50{
  background-color: rgb(240 253 244 / 0.5);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1);
}
.bg-green-500\\/20{
  background-color: rgb(34 197 94 / 0.2);
}
.bg-green-500\\/5{
  background-color: rgb(34 197 94 / 0.05);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600\\/20{
  background-color: rgb(79 70 229 / 0.2);
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/70{
  background-color: hsl(var(--muted) / 0.7);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-50\\/40{
  background-color: rgb(255 247 237 / 0.4);
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/10{
  background-color: rgb(249 115 22 / 0.1);
}
.bg-orange-500\\/20{
  background-color: rgb(249 115 22 / 0.2);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/15{
  background-color: hsl(var(--primary) / 0.15);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-primary\\/30{
  background-color: hsl(var(--primary) / 0.3);
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05);
}
.bg-primary\\/50{
  background-color: hsl(var(--primary) / 0.5);
}
.bg-primary\\/80{
  background-color: hsl(var(--primary) / 0.8);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/40{
  background-color: rgb(250 245 255 / 0.4);
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10{
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-500\\/20{
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-500\\/30{
  background-color: rgb(168 85 247 / 0.3);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15{
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/20{
  background-color: rgb(239 68 68 / 0.2);
}
.bg-red-500\\/5{
  background-color: rgb(239 68 68 / 0.05);
}
.bg-red-500\\/80{
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-400\\/15{
  background-color: rgb(148 163 184 / 0.15);
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/15{
  background-color: rgb(100 116 139 / 0.15);
}
.bg-slate-500\\/20{
  background-color: rgb(100 116 139 / 0.2);
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10{
  background-color: rgb(139 92 246 / 0.1);
}
.bg-violet-500\\/15{
  background-color: rgb(139 92 246 / 0.15);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50\\/20{
  background-color: rgb(254 252 232 / 0.2);
}
.bg-yellow-50\\/5{
  background-color: rgb(254 252 232 / 0.05);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/10{
  background-color: rgb(234 179 8 / 0.1);
}
.bg-yellow-500\\/20{
  background-color: rgb(234 179 8 / 0.2);
}
.bg-yellow-500\\/30{
  background-color: rgb(234 179 8 / 0.3);
}
.bg-yellow-500\\/5{
  background-color: rgb(234 179 8 / 0.05);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-\\[\\#1a8220\\]{
  --tw-gradient-from: #1a8220 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 130 32 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400{
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#0f4d13\\]{
  --tw-gradient-to: #0f4d13 var(--tw-gradient-to-position);
}
.to-\\[\\#15691a\\]{
  --tw-gradient-to: #15691a var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-0\\.5{
  padding-left: 0.125rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-16{
  padding-right: 4rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.5em\\]{
  letter-spacing: 0.5em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#334155\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#475569\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#4ade80\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#64748b\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#86efac\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#94a3b8\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#e2e8f0\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0B0C10\\]{
  --tw-text-opacity: 1;
  color: rgb(11 12 16 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0B3D91\\]{
  --tw-text-opacity: 1;
  color: rgb(11 61 145 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1FA21B\\]{
  --tw-text-opacity: 1;
  color: rgb(31 162 27 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1a1a\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4f46e5\\]{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-\\[\\#66FCF1\\]{
  --tw-text-opacity: 1;
  color: rgb(102 252 241 / var(--tw-text-opacity, 1));
}
.text-\\[\\#94a3b8\\]{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C5C6C7\\]{
  --tw-text-opacity: 1;
  color: rgb(197 198 199 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a5b4fc\\]{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-background{
  color: hsl(var(--background));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-cyan-500{
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8);
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-300{
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-400\\/70{
  color: rgb(74 222 128 / 0.7);
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-600\\/70{
  color: rgb(79 70 229 / 0.7);
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-muted-foreground\\/60{
  color: hsl(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-primary\\/30{
  color: hsl(var(--primary) / 0.3);
}
.text-primary\\/50{
  color: hsl(var(--primary) / 0.5);
}
.text-primary\\/60{
  color: hsl(var(--primary) / 0.6);
}
.text-primary\\/80{
  color: hsl(var(--primary) / 0.8);
}
.text-purple-300{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-400\\/70{
  color: rgb(248 113 113 / 0.7);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-400\\/70{
  color: rgb(250 204 21 / 0.7);
}
.text-yellow-400\\/80{
  color: rgb(250 204 21 / 0.8);
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.placeholder-slate-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#66FCF1\\]{
  accent-color: #66FCF1;
}
.accent-primary{
  accent-color: hsl(var(--primary));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_6px_hsl\\(var\\(--primary\\)\\/0\\.6\\)\\]{
  --tw-shadow: 0 0 6px hsl(var(--primary)/0.6);
  --tw-shadow-colored: 0 0 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_hsl\\(var\\(--primary\\)\\/0\\.4\\)\\]{
  --tw-shadow: 0 4px 14px hsl(var(--primary)/0.4);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_hsl\\(var\\(--primary\\)\\/0\\.25\\)\\]{
  --tw-shadow: 0 8px 20px hsl(var(--primary)/0.25);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgba\\(251\\2c 191\\2c 36\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 8px 20px rgba(251,191,36,0.3);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_hsl\\(var\\(--primary\\)\\/0\\.5\\)\\2c inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 8px 24px hsl(var(--primary)/0.5),inset 0 1px 0 rgba(255,255,255,0.2);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color), inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.5\\)\\2c inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 8px 24px rgba(16,185,129,0.5),inset 0 1px 0 rgba(255,255,255,0.2);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color), inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: inset 0 1px 3px rgba(0,0,0,0.06);
  --tw-shadow-colored: inset 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[30\\%\\]{
  --tw-grayscale: grayscale(30%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in{
  --tw-enter-scale: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-700{
  animation-duration: 700ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}

/* iOS momentum scrolling for all scrollable containers */
* {
    -webkit-overflow-scrolling: touch;
}

/* Custom scrollbar */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}
::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
}
::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
    border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover);
}

/* Glow effects */
.glow-cyan {
    box-shadow: 0 0 10px rgba(26, 130, 32, 0.2);
}
.glow-cyan-hover:hover {
    box-shadow: 0 0 20px rgba(26, 130, 32, 0.3);
}

/* Table styling */
.data-table th {
    background: var(--bg-tertiary);
    color: var(--text-secondary);
    border-bottom-width: 1px;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-color: var(--border-color);
}
.data-table td {
        font-family: 'JetBrains Mono', monospace;
        border-bottom-width: 1px;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        font-size: 0.875rem;
        line-height: 1.25rem;
    border-color: var(--border-light);
    }
.data-table tr:hover {
    background: var(--bg-tertiary);
}

/* Status badges - Light theme */
.status-approved{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.status-pending{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.status-rejected{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.status-suspended{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

[data-theme="dark"] .status-suspended       { background-color: #0d1f35; color: #64748b; border-color: rgba(30,41,59,.9); }

/* Animation — GPU-accelerated for smooth iOS rendering */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
    animation: fadeIn 0.3s ease-out forwards;
    will-change: transform, opacity;
}

/* Card hover effect */
.card-hover{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  animation-duration: 200ms;
}
.card-hover:hover{
  --tw-translate-y: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Theme-aware utility classes */
.theme-bg-primary { background-color: var(--bg-primary); }
.theme-bg-secondary { background-color: var(--bg-secondary); }
.theme-bg-tertiary { background-color: var(--bg-tertiary); }
.theme-text-primary { color: var(--text-primary); }
.theme-text-secondary { color: var(--text-secondary); }
.theme-text-muted { color: var(--text-muted); }
.theme-border { border-color: var(--border-color); }
.theme-card { background-color: var(--card-bg); }
.theme-input { background-color: var(--input-bg); }

/* Smooth theme transition */
.theme-transition {
    transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* ============= BANKING OVERRIDES ============= */
[data-theme="banking"] [role="tab"][data-state="active"] {
    background-color: #ffffff !important;
    color: #1a8220 !important;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08) !important;
}
[data-theme="banking"] input:focus,
[data-theme="banking"] textarea:focus {
    border-color: #1a8220 !important;
    box-shadow: 0 0 0 3px rgba(26, 130, 32, 0.12) !important;
}

/* ============= DARK THEME PAGE OVERRIDES ============= */
[data-theme="dark"] body {
    background-color: #060d1a;
    color: #e2e8f0;
}

/* Status badges — dark */
[data-theme="dark"] .status-approved  { background: rgba(34,197,94,.12);  color: #4ade80; border-color: rgba(34,197,94,.2); }
[data-theme="dark"] .status-pending   { background: rgba(251,191,36,.12); color: #fbbf24; border-color: rgba(251,191,36,.2); }
[data-theme="dark"] .status-rejected  { background: rgba(239,68,68,.12);  color: #f87171; border-color: rgba(239,68,68,.2); }
[data-theme="dark"] .status-suspended { background: rgba(100,116,139,.12);color: #94a3b8; border-color: rgba(100,116,139,.2); }

/* Surfaces */
[data-theme="dark"] .bg-white          { background-color: #0d1f35 !important; }
[data-theme="dark"] .bg-slate-50,
[data-theme="dark"] .bg-gray-50        { background-color: #0a1628 !important; }
[data-theme="dark"] .bg-slate-100,
[data-theme="dark"] .bg-gray-100       { background-color: #0d1f35 !important; }
[data-theme="dark"] .bg-slate-200,
[data-theme="dark"] .bg-gray-200       { background-color: #1e293b !important; }

/* Text */
[data-theme="dark"] .text-slate-900,
[data-theme="dark"] .text-gray-900     { color: #e2e8f0 !important; }
[data-theme="dark"] .text-slate-800,
[data-theme="dark"] .text-gray-800     { color: #cbd5e1 !important; }
[data-theme="dark"] .text-slate-700,
[data-theme="dark"] .text-gray-700     { color: #94a3b8 !important; }
[data-theme="dark"] .text-slate-600,
[data-theme="dark"] .text-gray-600     { color: #64748b !important; }
[data-theme="dark"] .text-slate-500,
[data-theme="dark"] .text-gray-500     { color: #475569 !important; }

/* Borders */
[data-theme="dark"] .border-slate-100,
[data-theme="dark"] .border-gray-100   { border-color: rgba(30,41,59,.6) !important; }
[data-theme="dark"] .border-slate-200,
[data-theme="dark"] .border-gray-200,
[data-theme="dark"] .border-[#e2e8f0]  { border-color: rgba(30,41,59,.9) !important; }
[data-theme="dark"] .border-slate-300,
[data-theme="dark"] .border-gray-300   { border-color: #334155 !important; }

/* Divide */
[data-theme="dark"] .divide-slate-100 > * + *,
[data-theme="dark"] .divide-gray-100 > * + * { border-color: rgba(30,41,59,.6) !important; }
[data-theme="dark"] .divide-slate-200 > * + *,
[data-theme="dark"] .divide-gray-200 > * + * { border-color: rgba(30,41,59,.9) !important; }

/* Inputs & selects */
[data-theme="dark"] input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
[data-theme="dark"] select,
[data-theme="dark"] textarea {
    background-color: #0d1f35 !important;
    color: #e2e8f0 !important;
    border-color: rgba(30,41,59,.9) !important;
}
[data-theme="dark"] input::placeholder,
[data-theme="dark"] textarea::placeholder { color: #475569 !important; }
[data-theme="dark"] select option         { background-color: #0d1f35; color: #e2e8f0; }

/* Focus ring */
[data-theme="dark"] input:focus,
[data-theme="dark"] select:focus,
[data-theme="dark"] textarea:focus {
    border-color: #1a8220 !important;
    box-shadow: 0 0 0 3px rgba(26,130,32,.2) !important;
}

/* Tabs */
[data-theme="dark"] [role="tablist"] {
    background-color: #0a1628 !important;
    border-color: rgba(30,41,59,.8) !important;
}
[data-theme="dark"] [role="tab"][data-state="active"] {
    background-color: #0d1f35 !important;
    color: #4ade80 !important;
    box-shadow: 0 1px 4px rgba(0,0,0,.3) !important;
}
[data-theme="dark"] [role="tab"]:not([data-state="active"]) { color: #94a3b8 !important; }

/* Dialogs / modals */
[data-theme="dark"] [role="dialog"] {
    background-color: #0d1f35 !important;
    border-color: rgba(30,41,59,.9) !important;
    color: #e2e8f0 !important;
}

/* Dropdown / popover menus */
[data-theme="dark"] [role="listbox"],
[data-theme="dark"] [role="menu"],
[data-theme="dark"] [data-radix-popper-content-wrapper] > div {
    background-color: #0d1f35 !important;
    border-color: rgba(30,41,59,.9) !important;
    color: #e2e8f0 !important;
}
[data-theme="dark"] [role="option"]:hover,
[data-theme="dark"] [role="menuitem"]:hover,
[data-theme="dark"] [role="option"][data-highlighted],
[data-theme="dark"] [role="menuitem"][data-highlighted] { background-color: #1e293b !important; }

/* Tables */
[data-theme="dark"] thead tr,
[data-theme="dark"] thead th {
    background-color: #0a1628 !important;
    border-color: rgba(30,41,59,.8) !important;
    color: #475569 !important;
}
[data-theme="dark"] tbody tr:hover   { background-color: rgba(13,31,53,.6) !important; }
[data-theme="dark"] tbody td         { border-color: rgba(15,23,42,.6) !important; color: #94a3b8 !important; }

/* data-table helper class */
[data-theme="dark"] .data-table th   { background: #0a1628; color: #475569; border-color: rgba(30,41,59,.8); }
[data-theme="dark"] .data-table td   { color: #94a3b8; border-color: rgba(15,23,42,.6); }
[data-theme="dark"] .data-table tr:hover { background: rgba(13,31,53,.6); }

/* Recharts tooltips */
[data-theme="dark"] .recharts-tooltip-wrapper .recharts-default-tooltip {
    background-color: #0d1f35 !important;
    border-color: rgba(30,41,59,.9) !important;
    color: #e2e8f0 !important;
}
[data-theme="dark"] .recharts-legend-item-text { color: #94a3b8 !important; }

/* Scrollbar — dark */
[data-theme="dark"] ::-webkit-scrollbar-track { background: #0a1628; }
[data-theme="dark"] ::-webkit-scrollbar-thumb { background: #1e293b; }
[data-theme="dark"] ::-webkit-scrollbar-thumb:hover { background: #334155; }

/* hide input number spinners */
input[type="number"] {
  appearance: textfield;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}
.file\\:cursor-pointer::file-selector-button{
  cursor: pointer;
}
.file\\:rounded::file-selector-button{
  border-radius: 0.25rem;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-primary\\/15::file-selector-button{
  background-color: hsl(var(--primary) / 0.15);
}
.file\\:bg-primary\\/80::file-selector-button{
  background-color: hsl(var(--primary) / 0.8);
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-1::file-selector-button{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:text-xs::file-selector-button{
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.file\\:text-primary::file-selector-button{
  color: hsl(var(--primary));
}
.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-foreground\\/30::placeholder{
  color: hsl(var(--foreground) / 0.3);
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-white\\/30::placeholder{
  color: rgb(255 255 255 / 0.3);
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:border-primary\\/40:focus-within{
  border-color: hsl(var(--primary) / 0.4);
}
.focus-within\\:bg-card:focus-within{
  background-color: hsl(var(--card));
}
.focus-within\\:bg-white:focus-within{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-primary\\/40:focus-within{
  --tw-ring-color: hsl(var(--primary) / 0.4);
}
.hover\\:border:hover{
  border-width: 1px;
}
.hover\\:border-\\[\\#1FA21B\\]\\/50:hover{
  border-color: rgb(31 162 27 / 0.5);
}
.hover\\:border-\\[\\#66FCF1\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(102 252 241 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#66FCF1\\]\\/50:hover{
  border-color: rgb(102 252 241 / 0.5);
}
.hover\\:border-amber-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary\\/40:hover{
  border-color: hsl(var(--primary) / 0.4);
}
.hover\\:border-primary\\/50:hover{
  border-color: hsl(var(--primary) / 0.5);
}
.hover\\:border-primary\\/70:hover{
  border-color: hsl(var(--primary) / 0.7);
}
.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#0B3D91\\]\\/10:hover{
  background-color: rgb(11 61 145 / 0.1);
}
.hover\\:bg-\\[\\#1F2833\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 40 51 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a8220\\]\\/5:hover{
  background-color: rgb(26 130 32 / 0.05);
}
.hover\\:bg-\\[\\#1e2235\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 34 53 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1e293b\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#4338ca\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#45A29E\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(69 162 158 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#66FCF1\\]\\/80:hover{
  background-color: rgb(102 252 241 / 0.8);
}
.hover\\:bg-\\[\\#66FCF1\\]\\/90:hover{
  background-color: rgb(102 252 241 / 0.9);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-background:hover{
  background-color: hsl(var(--background));
}
.hover\\:bg-black\\/80:hover{
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-card\\/10:hover{
  background-color: hsl(var(--card) / 0.1);
}
.hover\\:bg-card\\/20:hover{
  background-color: hsl(var(--card) / 0.2);
}
.hover\\:bg-card\\/5:hover{
  background-color: hsl(var(--card) / 0.05);
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-500\\/10:hover{
  background-color: rgb(16 185 129 / 0.1);
}
.hover\\:bg-emerald-500\\/25:hover{
  background-color: rgb(16 185 129 / 0.25);
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-400\\/10:hover{
  background-color: rgb(74 222 128 / 0.1);
}
.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-500\\/10:hover{
  background-color: rgb(34 197 94 / 0.1);
}
.hover\\:bg-green-500\\/30:hover{
  background-color: rgb(34 197 94 / 0.3);
}
.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-600\\/30:hover{
  background-color: rgb(79 70 229 / 0.3);
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/20:hover{
  background-color: hsl(var(--muted) / 0.2);
}
.hover\\:bg-muted\\/30:hover{
  background-color: hsl(var(--muted) / 0.3);
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-muted\\/60:hover{
  background-color: hsl(var(--muted) / 0.6);
}
.hover\\:bg-muted\\/70:hover{
  background-color: hsl(var(--muted) / 0.7);
}
.hover\\:bg-muted\\/80:hover{
  background-color: hsl(var(--muted) / 0.8);
}
.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-500\\/10:hover{
  background-color: rgb(249 115 22 / 0.1);
}
.hover\\:bg-orange-500\\/30:hover{
  background-color: rgb(249 115 22 / 0.3);
}
.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/10:hover{
  background-color: hsl(var(--primary) / 0.1);
}
.hover\\:bg-primary\\/15:hover{
  background-color: hsl(var(--primary) / 0.15);
}
.hover\\:bg-primary\\/30:hover{
  background-color: hsl(var(--primary) / 0.3);
}
.hover\\:bg-primary\\/5:hover{
  background-color: hsl(var(--primary) / 0.05);
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/85:hover{
  background-color: hsl(var(--primary) / 0.85);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-purple-400\\/10:hover{
  background-color: rgb(192 132 252 / 0.1);
}
.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-500\\/10:hover{
  background-color: rgb(168 85 247 / 0.1);
}
.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(239 68 68 / 0.1);
}
.hover\\:bg-red-500\\/30:hover{
  background-color: rgb(239 68 68 / 0.3);
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-400\\/10:hover{
  background-color: rgb(148 163 184 / 0.1);
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-transparent:hover{
  background-color: transparent;
}
.hover\\:bg-violet-500\\/25:hover{
  background-color: rgb(139 92 246 / 0.25);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:\\!text-\\[\\#94a3b8\\]:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.hover\\:\\!text-\\[\\#e2e8f0\\]:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1)) !important;
}
.hover\\:text-\\[\\#66FCF1\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(102 252 241 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.hover\\:text-card-foreground:hover{
  color: hsl(var(--card-foreground));
}
.hover\\:text-destructive:hover{
  color: hsl(var(--destructive));
}
.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-foreground\\/80:hover{
  color: hsl(var(--foreground) / 0.8);
}
.hover\\:text-green-300:hover{
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-500:hover{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-orange-300:hover{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-600:hover{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary:hover{
  color: hsl(var(--primary));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-primary\\/80:hover{
  color: hsl(var(--primary) / 0.8);
}
.hover\\:text-purple-300:hover{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-100:hover{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-70:hover{
  opacity: 0.7;
}
.hover\\:opacity-75:hover{
  opacity: 0.75;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.hover\\:shadow-\\[0_6px_20px_hsl\\(var\\(--primary\\)\\/0\\.5\\)\\]:hover{
  --tw-shadow: 0 6px 20px hsl(var(--primary)/0.5);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:file\\:bg-primary\\/15::file-selector-button:hover{
  background-color: hsl(var(--primary) / 0.15);
}
.focus\\:border-\\[\\#66FCF1\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(102 252 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-amber-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-primary:focus{
  border-color: hsl(var(--primary));
}
.focus\\:bg-\\[\\#1e293b\\]:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:bg-slate-100:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-primary:focus{
  --tw-ring-color: hsl(var(--primary));
}
.focus\\:ring-primary\\/20:focus{
  --tw-ring-color: hsl(var(--primary) / 0.2);
}
.focus\\:ring-primary\\/60:focus{
  --tw-ring-color: hsl(var(--primary) / 0.6);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:translate-y-px:active{
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:hover .group-hover\\:text-primary\\/80{
  color: hsl(var(--primary) / 0.8);
}
.group\\/msg:hover .group-hover\\/msg\\:opacity-100{
  opacity: 1;
}
.group\\/rep:hover .group-hover\\/rep\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-\\[\\#66FCF1\\][data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(102 252 241 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-amber-500\\/20[data-state="active"]{
  background-color: rgb(245 158 11 / 0.2);
}
.data-\\[state\\=active\\]\\:bg-amber-600[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=active\\]\\:bg-card[data-state="active"]{
  background-color: hsl(var(--card));
}
.data-\\[state\\=active\\]\\:bg-green-100[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-green-500\\/20[data-state="active"]{
  background-color: rgb(34 197 94 / 0.2);
}
.data-\\[state\\=active\\]\\:bg-orange-500[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-primary[data-state="active"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=active\\]\\:bg-primary\\/15[data-state="active"]{
  background-color: hsl(var(--primary) / 0.15);
}
.data-\\[state\\=active\\]\\:bg-purple-500\\/20[data-state="active"]{
  background-color: rgb(168 85 247 / 0.2);
}
.data-\\[state\\=active\\]\\:bg-purple-600[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-red-500\\/20[data-state="active"]{
  background-color: rgb(239 68 68 / 0.2);
}
.data-\\[state\\=active\\]\\:bg-yellow-500\\/20[data-state="active"]{
  background-color: rgb(234 179 8 / 0.2);
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-\\[\\#0B0C10\\][data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(11 12 16 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-amber-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-emerald-700[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=active\\]\\:text-green-400[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-green-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-indigo-700[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-primary[data-state="active"]{
  color: hsl(var(--primary));
}
.data-\\[state\\=active\\]\\:text-primary\\/60[data-state="active"]{
  color: hsl(var(--primary) / 0.6);
}
.data-\\[state\\=active\\]\\:text-purple-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-red-600[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-red-700[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-white[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-yellow-400[data-state="active"]{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
.dark\\:bg-slate-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:w-28{
    width: 7rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:text-left{
    text-align: left;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:max-h-none{
    max-height: none;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:w-80{
    width: 20rem;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:shrink-0{
    flex-shrink: 0;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:static{
    position: static;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:p-8{
    padding: 2rem;
  }
}
@media (min-width: 1280px){

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd,0BAAc;;AAAd;QAAA,yBAAc;QAAd,yBAAc;QAAd,iBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,qBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,oBAAc;QAAd,sBAAc;QAAd,kBAAc;QAAd,sBAAc;QAAd,sBAAc;;QAAd,0BAAc;QAAd,qBAAc;QAAd,uBAAc;QAAd,sBAAc;QAAd,uBAAc;QAAd,yBAAc;QAAd,qBAAc;QAAd,uBAAc;QAAd,uBAAc;QAAd,qBAAc;QAAd,yBAAc;QAAd,uBAAc;QAAd,8BAAc;QAAd,4BAAc;QAAd,qCAAc;QAAd,kBAAc;QAAd,mBAAc;QAAd,0BAAc;QAAd,0BAAc;QAAd,gCAAc;IAAA;;AAAd,eAAc;;AAAd;QAAA,wBAAc;QAAd,yBAAc;QAAd,mBAAc;QAAd,8BAAc;QAAd,qBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,qBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,sBAAc;QAAd,sBAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,sBAAc;QAAd,gBAAc;QAAd,sBAAc;QAAd,qBAAc;;QAAd,0BAAc;QAAd,qBAAc;QAAd,uBAAc;QAAd,sBAAc;QAAd,uBAAc;QAAd,yBAAc;QAAd,qBAAc;QAAd,qCAAc;QAAd,qCAAc;QAAd,qBAAc;QAAd,uCAAc;QAAd,uBAAc;QAAd,8BAAc;QAAd,4CAAc;QAAd,mCAAc;QAAd,kBAAc;QAAd,mBAAc;QAAd,uBAAc;QAAd,0BAAc;QAAd,0BAAc;QAAd,gCAAc;IAAA;;AAAd,yCAAc;;AAAd;QAAA,yBAAc;QAAd,yBAAc;QAAd,iBAAc;QAAd,8BAAc;QAAd,oBAAc;QAAd,iCAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,qBAAc;QAAd,8BAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,mBAAc;QAAd,gBAAc;;QAAd,0BAAc;QAAd,qBAAc;QAAd,uBAAc;QAAd,sBAAc;QAAd,uBAAc;QAAd,yBAAc;QAAd,qBAAc;QAAd,uBAAc;QAAd,uBAAc;QAAd,qBAAc;QAAd,yBAAc;QAAd,uBAAc;QAAd,8BAAc;QAAd,4CAAc;QAAd,qCAAc;QAAd,kBAAc;QAAd,mBAAc;QAAd,uBAAc;QAAd,0BAAc;QAAd,0BAAc;QAAd,gCAAc;IAAA;;AAAd;EAAA,gCAAc;QAAd,qDAAc;QAAd;AAAc;;AAAd;QAAA,mCAAc;QAAd,0BAAc;QAAd,4DAAc;QAAd,mCAAc;QAAd,kCAAc;QAAd,wCAAc;QAAd,yBAAc;IAAA;;AAAd,wDAAc;;AAAd;;QAAA,iFAAc;IAAA;;AAAd;QAAA,qDAAc;QAAd,uBAAc;IAAA;;AAAd;QAAA,wCAAc;IAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAwLnB,yDAAyD;AACzD;IACI,iCAAiC;AACrC;;AAEA,qBAAqB;AACrB;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,wCAAwC;AAC5C;;AAEA,iBAAiB;AACjB;IACI,2CAA2C;AAC/C;AACA;IACI,2CAA2C;AAC/C;;AAEA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,wBAA0D;IAA1D,kBAA0D;IAA1D,iBAA0D;IAA1D,gBAA0D;IAA1D,yBAA0D;IAA1D,sBAA0D;IAC1D,iCAAiC;AACrC;AAEI;QAAA,wCAA2C;QAA3C,wBAA2C;QAA3C,oBAA2C;QAA3C,uBAA2C;QAA3C,kBAA2C;QAA3C,mBAA2C;QAA3C,+GAA2C;QAA3C,mBAA2C;QAA3C,oBAA2C;IAC3C,iCAAiC;IADU;AAG/C;IACI,8BAA8B;AAClC;;AAEA,gCAAgC;AACb;EAAA,iBAA0D;EAA1D,sBAA0D;EAA1D,4DAA0D;EAA1D,kBAA0D;EAA1D,4DAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AAC3D;EAAA,iBAA6D;EAA7D,sBAA6D;EAA7D,4DAA6D;EAA7D,kBAA6D;EAA7D,4DAA6D;EAA7D,oBAA6D;EAA7D;AAA6D;AAC5D;EAAA,iBAAoD;EAApD,sBAAoD;EAApD,4DAAoD;EAApD,kBAAoD;EAApD,4DAAoD;EAApD,oBAAoD;EAApD;AAAoD;AACnD;EAAA,iBAAuD;EAAvD,sBAAuD;EAAvD,4DAAuD;EAAvD,kBAAuD;EAAvD,4DAAuD;EAAvD,oBAAuD;EAAvD;AAAuD;AAAvD;8CAAA,yBAAuD,EAAvD,cAAuD,EAAvD,+BAAuD,EAAA;;AAE3E,yDAAyD;AACzD;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;IACI,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA,sBAAsB;AAElB;EAAA,wBAAkC;EAAlC,wDAAkC;EAAlC,0BAAkC;EAAlC;AAAkC;AAGlC;EAAA,sBAAmC;EAAnC,+LAAmC;EAAnC,+EAAmC;EAAnC,mGAAmC;EAAnC;AAAmC;;AAGvC,gCAAgC;AAChC,oBAAoB,mCAAmC,EAAE;AACzD,sBAAsB,qCAAqC,EAAE;AAC7D,qBAAqB,oCAAoC,EAAE;AAC3D,sBAAsB,0BAA0B,EAAE;AAClD,wBAAwB,4BAA4B,EAAE;AACtD,oBAAoB,wBAAwB,EAAE;AAC9C,gBAAgB,iCAAiC,EAAE;AACnD,cAAc,gCAAgC,EAAE;AAChD,eAAe,iCAAiC,EAAE;;AAElD,4BAA4B;AAC5B;IACI,+EAA+E;AACnF;;AAEA,kDAAkD;AAClD;IACI,oCAAoC;IACpC,yBAAyB;IACzB,iDAAiD;AACrD;AACA;;IAEI,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA,0DAA0D;AAC1D;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,yBAAyB;AACzB,wCAAwC,+BAA+B,GAAG,cAAc,EAAE,gCAAgC,EAAE;AAC5H,wCAAwC,gCAAgC,EAAE,cAAc,EAAE,iCAAiC,EAAE;AAC7H,wCAAwC,+BAA+B,GAAG,cAAc,EAAE,gCAAgC,EAAE;AAC5H,wCAAwC,iCAAiC,CAAC,cAAc,EAAE,kCAAkC,EAAE;;AAE9H,aAAa;AACb,yCAAyC,oCAAoC,EAAE;AAC/E;yCACyC,oCAAoC,EAAE;AAC/E;yCACyC,oCAAoC,EAAE;AAC/E;yCACyC,oCAAoC,EAAE;;AAE/E,SAAS;AACT;yCACyC,yBAAyB,EAAE;AACpE;yCACyC,yBAAyB,EAAE;AACpE;yCACyC,yBAAyB,EAAE;AACpE;yCACyC,yBAAyB,EAAE;AACpE;yCACyC,yBAAyB,EAAE;;AAEpE,YAAY;AACZ;yCACyC,0CAA0C,EAAE;AACrF;;yCAEyC,0CAA0C,EAAE;AACrF;yCACyC,gCAAgC,EAAE;;AAE3E,WAAW;AACX;+CAC+C,0CAA0C,EAAE;AAC3F;+CAC+C,0CAA0C,EAAE;;AAE3F,qBAAqB;AACrB;;;IAGI,oCAAoC;IACpC,yBAAyB;IACzB,0CAA0C;AAC9C;AACA;4CAC4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE,cAAc,EAAE;;AAEvF,eAAe;AACf;;;IAGI,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA,SAAS;AACT;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,+CAA+C;AACnD;AACA,8DAA8D,yBAAyB,EAAE;;AAEzF,qBAAqB;AACrB;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;;;IAGI,oCAAoC;IACpC,0CAA0C;IAC1C,yBAAyB;AAC7B;AACA;;;0DAG0D,oCAAoC,EAAE;;AAEhG,WAAW;AACX;;IAEI,oCAAoC;IACpC,0CAA0C;IAC1C,yBAAyB;AAC7B;AACA,uCAAuC,8CAA8C,EAAE;AACvF,uCAAuC,0CAA0C,EAAE,yBAAyB,EAAE;;AAE9G,4BAA4B;AAC5B,uCAAuC,mBAAmB,EAAE,cAAc,EAAE,+BAA+B,EAAE;AAC7G,uCAAuC,cAAc,EAAE,+BAA+B,EAAE;AACxF,2CAA2C,6BAA6B,EAAE;;AAE1E,sBAAsB;AACtB;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,yBAAyB;AAC7B;AACA,iDAAiD,yBAAyB,EAAE;;AAE5E,qBAAqB;AACrB,gDAAgD,mBAAmB,EAAE;AACrE,gDAAgD,mBAAmB,EAAE;AACrE,sDAAsD,mBAAmB,EAAE;;AAE3E,+BAA+B;AAC/B;EAEE,qBAAqB;AACvB;AACA;;EAEE,wBAAwB;EACxB,aAAa;AACf;AAraA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA,QAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,iDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,+BAsaA;EAtaA;AAsaA;AAtaA;EAAA,+BAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,+CAsaA;EAtaA,sDAsaA;EAtaA;AAsaA;AAtaA;EAAA,6EAsaA;EAtaA,iGAsaA;EAtaA;AAsaA;AAtaA;EAAA,0CAsaA;EAtaA,uDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA,2GAsaA;EAtaA,yGAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,+EAsaA;EAtaA,mGAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,yBAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,yBAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,gDAsaA;EAtaA;AAsaA;AAtaA;EAAA,iDAsaA;EAtaA;AAsaA;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;AAtaA;EAAA;AAsaA;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,0EAsaA;EAtaA,8FAsaA;EAtaA;AAsaA;AAtaA;EAAA,0CAsaA;EAtaA,uDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA,yBAsaA;EAtaA,2BAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,+BAsaA;EAtaA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA,yBAsaA;EAtaA,2BAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,+BAsaA;EAtaA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA,yBAsaA;EAtaA,2BAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,+BAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,wBAsaA;EAtaA,yBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,wBAsaA;EAtaA,yBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,wBAsaA;EAtaA,yBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA,yBAsaA;EAtaA,0BAsaA;EAtaA,wBAsaA;EAtaA,yBAsaA;EAtaA,8BAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA,0BAsaA;EAtaA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,sDAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,oDAsaA;IAtaA;EAsaA;;EAtaA;IAAA,uBAsaA;IAtaA,2DAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,oBAsaA;IAtaA;EAsaA;;EAtaA;IAAA,mBAsaA;IAtaA;EAsaA;AAAA;AAtaA;;EAAA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA,qBAsaA;IAtaA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;;EAtaA;IAAA;EAsaA;AAAA;AAtaA;;EAAA;IAAA;EAsaA;AAAA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kDAsaA;EAtaA;AAsaA;AAtaA;EAAA,iDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,iDAsaA;EAtaA;AAsaA;AAtaA;EAAA,kDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kDAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,gBAsaA;EAtaA,oBAsaA;EAtaA,4BAsaA;EAtaA;AAsaA;AAtaA;EAAA,sBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,WAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA,mBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,qBAsaA;EAtaA;AAsaA;AAtaA;EAAA,kBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA,oBAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA,WAsaA;EAtaA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA;AAtaA;EAAA;AAsaA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700&family=Manrope:wght@400;500;700&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    /* Light Theme (Default) */\n    :root {\n        --background: 210 40% 98%;\n        --foreground: 222 47% 11%;\n        --card: 0 0% 100%;\n        --card-foreground: 222 47% 11%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 222 47% 11%;\n        --primary: 118 72% 37%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 210 40% 96%;\n        --secondary-foreground: 222 47% 11%;\n        --muted: 210 40% 96%;\n        --muted-foreground: 215 16% 47%;\n        --accent: 118 72% 37%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 4 84% 60%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 214 32% 91%;\n        --input: 214 32% 91%;\n        --ring: 118 72% 37%;\n        --chart-1: 118 72% 37%;\n        --chart-2: 145 80% 42%;\n        --chart-3: 48 100% 50%;\n        --chart-4: 4 84% 60%;\n        --chart-5: 280 70% 60%;\n        --radius: 0.375rem;\n        --success: 145 80% 42%;\n        --warning: 48 100% 50%;\n\n        /* Theme-specific colors */\n        --bg-primary: #F8FAFC;\n        --bg-secondary: #FFFFFF;\n        --bg-tertiary: #F1F5F9;\n        --text-primary: #1E293B;\n        --text-secondary: #64748B;\n        --text-muted: #94A3B8;\n        --border-color: #E2E8F0;\n        --border-light: #F1F5F9;\n        --sidebar-bg: #FFFFFF;\n        --sidebar-border: #E2E8F0;\n        --sidebar-text: #64748B;\n        --sidebar-text-active: #1a8220;\n        --sidebar-bg-active: #f0fdf4;\n        --header-bg: rgba(255, 255, 255, 0.8);\n        --card-bg: #FFFFFF;\n        --input-bg: #F8FAFC;\n        --scrollbar-track: #F1F5F9;\n        --scrollbar-thumb: #CBD5E1;\n        --scrollbar-thumb-hover: #94A3B8;\n    }\n\n    /* Dark Theme */\n    [data-theme=\"dark\"] {\n        --background: 222 47% 7%;\n        --foreground: 210 40% 92%;\n        --card: 222 47% 11%;\n        --card-foreground: 210 40% 92%;\n        --popover: 222 47% 9%;\n        --popover-foreground: 210 40% 92%;\n        --primary: 118 60% 50%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 222 47% 14%;\n        --secondary-foreground: 210 40% 80%;\n        --muted: 222 47% 14%;\n        --muted-foreground: 215 20% 45%;\n        --accent: 118 60% 50%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 4 84% 60%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 222 47% 16%;\n        --input: 222 47% 14%;\n        --ring: 118 60% 50%;\n        --chart-1: 118 60% 55%;\n        --chart-2: 145 60% 55%;\n        --chart-3: 48 90% 60%;\n        --chart-4: 4 84% 60%;\n        --chart-5: 280 60% 65%;\n        --radius: 0.5rem;\n        --success: 145 60% 55%;\n        --warning: 48 90% 60%;\n\n        /* Theme-specific colors */\n        --bg-primary: #060d1a;\n        --bg-secondary: #0a1628;\n        --bg-tertiary: #0d1f35;\n        --text-primary: #e2e8f0;\n        --text-secondary: #94a3b8;\n        --text-muted: #475569;\n        --border-color: rgba(30, 41, 59, 0.9);\n        --border-light: rgba(15, 23, 42, 0.6);\n        --sidebar-bg: #0a1628;\n        --sidebar-border: rgba(30, 41, 59, 0.8);\n        --sidebar-text: #64748b;\n        --sidebar-text-active: #4ade80;\n        --sidebar-bg-active: rgba(26, 130, 32, 0.08);\n        --header-bg: rgba(10, 22, 40, 0.95);\n        --card-bg: #0d1f35;\n        --input-bg: #0d1f35;\n        --accent-color: #1a8220;\n        --scrollbar-track: #0a1628;\n        --scrollbar-thumb: #1e293b;\n        --scrollbar-thumb-hover: #334155;\n    }\n\n    /* Banking Theme — Modern Banking White */\n    [data-theme=\"banking\"] {\n        --background: 210 40% 98%;\n        --foreground: 222 47% 11%;\n        --card: 0 0% 100%;\n        --card-foreground: 222 47% 11%;\n        --popover: 0 0% 100%;\n        --popover-foreground: 222 47% 11%;\n        --primary: 118 72% 37%;\n        --primary-foreground: 0 0% 100%;\n        --secondary: 210 40% 96%;\n        --secondary-foreground: 222 47% 11%;\n        --muted: 210 40% 96%;\n        --muted-foreground: 215 16% 47%;\n        --accent: 118 72% 37%;\n        --accent-foreground: 0 0% 100%;\n        --destructive: 4 84% 60%;\n        --destructive-foreground: 0 0% 100%;\n        --border: 214 32% 91%;\n        --input: 214 32% 91%;\n        --ring: 118 72% 37%;\n        --radius: 0.5rem;\n\n        /* Theme-specific colors */\n        --bg-primary: #f8fafc;\n        --bg-secondary: #ffffff;\n        --bg-tertiary: #f1f5f9;\n        --text-primary: #1e293b;\n        --text-secondary: #64748b;\n        --text-muted: #94a3b8;\n        --border-color: #e2e8f0;\n        --border-light: #f8fafc;\n        --sidebar-bg: #0f172a;\n        --sidebar-border: #1e293b;\n        --sidebar-text: #64748b;\n        --sidebar-text-active: #86efac;\n        --sidebar-bg-active: rgba(26, 130, 32, 0.15);\n        --header-bg: rgba(255, 255, 255, 0.9);\n        --card-bg: #ffffff;\n        --input-bg: #f8fafc;\n        --accent-color: #1a8220;\n        --scrollbar-track: #f1f5f9;\n        --scrollbar-thumb: #cbd5e1;\n        --scrollbar-thumb-hover: #94a3b8;\n    }\n\n}\n\n@layer base {\n    * {\n        @apply border-border;\n        /* Remove iOS tap delay on all interactive elements */\n        touch-action: manipulation;\n    }\n    body {\n        background-color: var(--bg-primary);\n        color: var(--text-primary);\n        font-family: var(--app-font, 'Inter', 'Manrope', sans-serif);\n        @apply antialiased;\n        -webkit-tap-highlight-color: transparent;\n        overscroll-behavior: none;\n    }\n    /* Banking: Plus Jakarta Sans / Inter for all elements */\n    [data-theme=\"banking\"] body,\n    [data-theme=\"banking\"] * {\n        font-family: var(--app-font, 'Plus Jakarta Sans', 'Inter', sans-serif) !important;\n    }\n    h1, h2, h3, h4, h5, h6 {\n        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;\n        letter-spacing: -0.02em;\n    }\n    code, .font-mono {\n        font-family: 'JetBrains Mono', monospace;\n    }\n}\n\n/* iOS momentum scrolling for all scrollable containers */\n* {\n    -webkit-overflow-scrolling: touch;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n::-webkit-scrollbar-track {\n    background: var(--scrollbar-track);\n}\n::-webkit-scrollbar-thumb {\n    background: var(--scrollbar-thumb);\n    border-radius: 4px;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: var(--scrollbar-thumb-hover);\n}\n\n/* Glow effects */\n.glow-cyan {\n    box-shadow: 0 0 10px rgba(26, 130, 32, 0.2);\n}\n.glow-cyan-hover:hover {\n    box-shadow: 0 0 20px rgba(26, 130, 32, 0.3);\n}\n\n/* Table styling */\n.data-table th {\n    background: var(--bg-tertiary);\n    color: var(--text-secondary);\n    @apply font-bold uppercase tracking-wider text-xs border-b;\n    border-color: var(--border-color);\n}\n.data-table td {\n    @apply py-3 px-4 font-mono text-sm border-b;\n    border-color: var(--border-light);\n}\n.data-table tr:hover {\n    background: var(--bg-tertiary);\n}\n\n/* Status badges - Light theme */\n.status-approved { @apply bg-green-100 text-green-700 border border-green-200; }\n.status-pending { @apply bg-yellow-100 text-yellow-700 border border-yellow-200; }\n.status-rejected { @apply bg-red-100 text-red-700 border border-red-200; }\n.status-suspended { @apply bg-gray-100 text-gray-600 border border-gray-200; }\n\n/* Animation — GPU-accelerated for smooth iOS rendering */\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n.animate-fade-in {\n    animation: fadeIn 0.3s ease-out forwards;\n    will-change: transform, opacity;\n}\n\n/* Card hover effect */\n.card-hover {\n    @apply transition-all duration-200;\n}\n.card-hover:hover {\n    @apply translate-y-[-2px] shadow-lg;\n}\n\n/* Theme-aware utility classes */\n.theme-bg-primary { background-color: var(--bg-primary); }\n.theme-bg-secondary { background-color: var(--bg-secondary); }\n.theme-bg-tertiary { background-color: var(--bg-tertiary); }\n.theme-text-primary { color: var(--text-primary); }\n.theme-text-secondary { color: var(--text-secondary); }\n.theme-text-muted { color: var(--text-muted); }\n.theme-border { border-color: var(--border-color); }\n.theme-card { background-color: var(--card-bg); }\n.theme-input { background-color: var(--input-bg); }\n\n/* Smooth theme transition */\n.theme-transition {\n    transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;\n}\n\n/* ============= BANKING OVERRIDES ============= */\n[data-theme=\"banking\"] [role=\"tab\"][data-state=\"active\"] {\n    background-color: #ffffff !important;\n    color: #1a8220 !important;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.08) !important;\n}\n[data-theme=\"banking\"] input:focus,\n[data-theme=\"banking\"] textarea:focus {\n    border-color: #1a8220 !important;\n    box-shadow: 0 0 0 3px rgba(26, 130, 32, 0.12) !important;\n}\n\n/* ============= DARK THEME PAGE OVERRIDES ============= */\n[data-theme=\"dark\"] body {\n    background-color: #060d1a;\n    color: #e2e8f0;\n}\n\n/* Status badges — dark */\n[data-theme=\"dark\"] .status-approved  { background: rgba(34,197,94,.12);  color: #4ade80; border-color: rgba(34,197,94,.2); }\n[data-theme=\"dark\"] .status-pending   { background: rgba(251,191,36,.12); color: #fbbf24; border-color: rgba(251,191,36,.2); }\n[data-theme=\"dark\"] .status-rejected  { background: rgba(239,68,68,.12);  color: #f87171; border-color: rgba(239,68,68,.2); }\n[data-theme=\"dark\"] .status-suspended { background: rgba(100,116,139,.12);color: #94a3b8; border-color: rgba(100,116,139,.2); }\n\n/* Surfaces */\n[data-theme=\"dark\"] .bg-white          { background-color: #0d1f35 !important; }\n[data-theme=\"dark\"] .bg-slate-50,\n[data-theme=\"dark\"] .bg-gray-50        { background-color: #0a1628 !important; }\n[data-theme=\"dark\"] .bg-slate-100,\n[data-theme=\"dark\"] .bg-gray-100       { background-color: #0d1f35 !important; }\n[data-theme=\"dark\"] .bg-slate-200,\n[data-theme=\"dark\"] .bg-gray-200       { background-color: #1e293b !important; }\n\n/* Text */\n[data-theme=\"dark\"] .text-slate-900,\n[data-theme=\"dark\"] .text-gray-900     { color: #e2e8f0 !important; }\n[data-theme=\"dark\"] .text-slate-800,\n[data-theme=\"dark\"] .text-gray-800     { color: #cbd5e1 !important; }\n[data-theme=\"dark\"] .text-slate-700,\n[data-theme=\"dark\"] .text-gray-700     { color: #94a3b8 !important; }\n[data-theme=\"dark\"] .text-slate-600,\n[data-theme=\"dark\"] .text-gray-600     { color: #64748b !important; }\n[data-theme=\"dark\"] .text-slate-500,\n[data-theme=\"dark\"] .text-gray-500     { color: #475569 !important; }\n\n/* Borders */\n[data-theme=\"dark\"] .border-slate-100,\n[data-theme=\"dark\"] .border-gray-100   { border-color: rgba(30,41,59,.6) !important; }\n[data-theme=\"dark\"] .border-slate-200,\n[data-theme=\"dark\"] .border-gray-200,\n[data-theme=\"dark\"] .border-[#e2e8f0]  { border-color: rgba(30,41,59,.9) !important; }\n[data-theme=\"dark\"] .border-slate-300,\n[data-theme=\"dark\"] .border-gray-300   { border-color: #334155 !important; }\n\n/* Divide */\n[data-theme=\"dark\"] .divide-slate-100 > * + *,\n[data-theme=\"dark\"] .divide-gray-100 > * + * { border-color: rgba(30,41,59,.6) !important; }\n[data-theme=\"dark\"] .divide-slate-200 > * + *,\n[data-theme=\"dark\"] .divide-gray-200 > * + * { border-color: rgba(30,41,59,.9) !important; }\n\n/* Inputs & selects */\n[data-theme=\"dark\"] input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\n[data-theme=\"dark\"] select,\n[data-theme=\"dark\"] textarea {\n    background-color: #0d1f35 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(30,41,59,.9) !important;\n}\n[data-theme=\"dark\"] input::placeholder,\n[data-theme=\"dark\"] textarea::placeholder { color: #475569 !important; }\n[data-theme=\"dark\"] select option         { background-color: #0d1f35; color: #e2e8f0; }\n\n/* Focus ring */\n[data-theme=\"dark\"] input:focus,\n[data-theme=\"dark\"] select:focus,\n[data-theme=\"dark\"] textarea:focus {\n    border-color: #1a8220 !important;\n    box-shadow: 0 0 0 3px rgba(26,130,32,.2) !important;\n}\n\n/* Tabs */\n[data-theme=\"dark\"] [role=\"tablist\"] {\n    background-color: #0a1628 !important;\n    border-color: rgba(30,41,59,.8) !important;\n}\n[data-theme=\"dark\"] [role=\"tab\"][data-state=\"active\"] {\n    background-color: #0d1f35 !important;\n    color: #4ade80 !important;\n    box-shadow: 0 1px 4px rgba(0,0,0,.3) !important;\n}\n[data-theme=\"dark\"] [role=\"tab\"]:not([data-state=\"active\"]) { color: #94a3b8 !important; }\n\n/* Dialogs / modals */\n[data-theme=\"dark\"] [role=\"dialog\"] {\n    background-color: #0d1f35 !important;\n    border-color: rgba(30,41,59,.9) !important;\n    color: #e2e8f0 !important;\n}\n\n/* Dropdown / popover menus */\n[data-theme=\"dark\"] [role=\"listbox\"],\n[data-theme=\"dark\"] [role=\"menu\"],\n[data-theme=\"dark\"] [data-radix-popper-content-wrapper] > div {\n    background-color: #0d1f35 !important;\n    border-color: rgba(30,41,59,.9) !important;\n    color: #e2e8f0 !important;\n}\n[data-theme=\"dark\"] [role=\"option\"]:hover,\n[data-theme=\"dark\"] [role=\"menuitem\"]:hover,\n[data-theme=\"dark\"] [role=\"option\"][data-highlighted],\n[data-theme=\"dark\"] [role=\"menuitem\"][data-highlighted] { background-color: #1e293b !important; }\n\n/* Tables */\n[data-theme=\"dark\"] thead tr,\n[data-theme=\"dark\"] thead th {\n    background-color: #0a1628 !important;\n    border-color: rgba(30,41,59,.8) !important;\n    color: #475569 !important;\n}\n[data-theme=\"dark\"] tbody tr:hover   { background-color: rgba(13,31,53,.6) !important; }\n[data-theme=\"dark\"] tbody td         { border-color: rgba(15,23,42,.6) !important; color: #94a3b8 !important; }\n\n/* data-table helper class */\n[data-theme=\"dark\"] .data-table th   { background: #0a1628; color: #475569; border-color: rgba(30,41,59,.8); }\n[data-theme=\"dark\"] .data-table td   { color: #94a3b8; border-color: rgba(15,23,42,.6); }\n[data-theme=\"dark\"] .data-table tr:hover { background: rgba(13,31,53,.6); }\n\n/* Recharts tooltips */\n[data-theme=\"dark\"] .recharts-tooltip-wrapper .recharts-default-tooltip {\n    background-color: #0d1f35 !important;\n    border-color: rgba(30,41,59,.9) !important;\n    color: #e2e8f0 !important;\n}\n[data-theme=\"dark\"] .recharts-legend-item-text { color: #94a3b8 !important; }\n\n/* Scrollbar — dark */\n[data-theme=\"dark\"] ::-webkit-scrollbar-track { background: #0a1628; }\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb { background: #1e293b; }\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb:hover { background: #334155; }\n\n/* hide input number spinners */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
